export const FirebaseConfig = {
    apiKey: 'AIzaSyCJ-Xaa_0x_m_UKLWh60v-Mg3wVbdVQchY',
    authDomain: 'kwaiwebpwa.firebaseapp.com',
    projectId: 'kwaiwebpwa',
    storageBucket: 'kwaiwebpwa.firebasestorage.app',
    messagingSenderId: '35760235920',
    appId: '1:35760235920:web:9359fdd864b26388ff7f15',
    measurementId: 'G-QNGYR155ZV',
};
